import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import {DossierBloqueDto, ResultFixedAnomaliesDto, ValidationResultsDto} from "@resources/resources";
import {TypeResultatSaisie} from "@common/constants/TypeResultatSaisie";
import {TypeAnomalies} from "@common/constants/TypeAnomalie";
import {EtatEnums} from "@common/enum/Etat.enum";
import { DatePipe } from '@angular/common';


@Component({
  selector: 'body-donnees-manquantes',
  templateUrl: './body-donnees-manquantes.html'
})
export class BodyDonneesManquantes implements OnInit {
  @Output() setData: EventEmitter<any> = new EventEmitter();
  @Output() hasChampsValides: EventEmitter<any> = new EventEmitter();
  @Output() hasVisaRequired: EventEmitter<any> = new EventEmitter();
  @Input() dossierBloqueDto: DossierBloqueDto;
  @Input() apiResult: ResultFixedAnomaliesDto;
  isValeurValide: boolean;
  returnMessage: string;
  isMissedResultatAnlayseSaisie : boolean;
  numericRegex: RegExp;
  readonly MAX_CARACTERES :number = 9;
  readonly YEAR_DIGIT : number = 20;

  identicalInput: boolean = false;
  valeurInitial: string = '';
  isBoutonValiderClique = false;
  isDonneesDiscordantes = false;


  constructor(private datePipe: DatePipe) {}


  ngOnInit() {
    if (this.isNumeriqueInputResultat()){
      this.dossierBloqueDto.resultatAnalyseConfirm = false;
    }

    this.isValeurValide = true;
    this.numericRegex = RegExp(/^[-]?[0-9]+([\.,]?[0-9]+)?$/);
    if(this.isEtatTermine() && this.dossierBloqueDto.typeResultatAttendu == TypeResultatSaisie.DATE)
      this.afficherDateEtatTermine();
  }

  isTypeAnomalyResultat(){
    return this.dossierBloqueDto.typeAnomalie == TypeAnomalies.RESULTATS;

  }

  isNumeriqueInputResultat() {
    return this.dossierBloqueDto.typeResultatAttendu == TypeResultatSaisie.NUMERIQUE && this.isTypeAnomalyResultat() && this.isEtatEnCours();
  }

  isCodeInputResultat() {
    return this.dossierBloqueDto.typeResultatAttendu == TypeResultatSaisie.CODES && this.isTypeAnomalyResultat() && this.isEtatEnCours();
  }

  isDateInputResultat(){
    return  this.dossierBloqueDto.typeResultatAttendu == TypeResultatSaisie.DATE && this.isTypeAnomalyResultat() && this.isEtatEnCours();
  }


  isEtatTermine() {
    return this.dossierBloqueDto.etat == EtatEnums.TERMINE.value();
  }

  afficherDateEtatTermine(){
     let digitDate  = this.dossierBloqueDto.resultatAnalyseSaisie;
     this.dossierBloqueDto.resultatAnalyseSaisie= digitDate.substring(0,2)+'/'+digitDate.substring(2,4)+'/'+this.YEAR_DIGIT+ digitDate.substring(4,6);
  }


  datePickerEvent(date : Date){
    this.dossierBloqueDto.resultatAnalyseSaisie = this.datePipe.transform(date,'ddMMyy');
    if(! this.isEmpty(this.dossierBloqueDto.resultatAnalyseSaisie)){
      this.dossierBloqueDto.resultatAnalyseConfirm = true;
      this.hasChampsValides.emit(true);
      this.inputChange();
    }

  }

  isEtatEnCours() {
    return this.dossierBloqueDto.etat == EtatEnums.EN_COURS.value();
  }

  hasSeuilSup() {
    return this.dossierBloqueDto.seuilAlerteSup != null;
  }

  hasSeuilInf() {
    return this.dossierBloqueDto.seuilAlerteInf != null;
  }

  isEmpty(str: string) {
    return str == null || false || str.length === 0;
  }

  isFloat(){
    return this.dossierBloqueDto.resultatAnalyseSaisie.includes('.');
  }

  isValeurNumeriqueValide() {
    if (this.isEmpty(this.dossierBloqueDto.resultatAnalyseSaisie)) return false;
    return this._compareSeuils() && !this.isFloat();
  }

  _compareSeuils(): boolean {
    return this.hasSeuilInf() && this.hasSeuilSup()
      ? this._compareBetweenSeuils()
      : this._compareOneSeuilOrNone();
  }

  _compareBetweenSeuils(): boolean {
    return Number(this.dossierBloqueDto.resultatAnalyseSaisie) >= this.dossierBloqueDto.seuilAlerteInf &&
      Number(this.dossierBloqueDto.resultatAnalyseSaisie) <= this.dossierBloqueDto.seuilAlerteSup;
  }

  _compareOneSeuilOrNone(): boolean {
    if (this.hasSeuilInf()) {
      return Number(this.dossierBloqueDto.resultatAnalyseSaisie) >= this.dossierBloqueDto.seuilAlerteInf;
    }
    if (this.hasSeuilSup()) {
      return Number(this.dossierBloqueDto.resultatAnalyseSaisie) <= this.dossierBloqueDto.seuilAlerteSup;
    }
    // Il n'y a pas de seuil, toute valeur numérique est donc valide
    return true;
  }

  isValeurNumeriqueMatch() {
    return this.numericRegex.test(this.dossierBloqueDto.resultatAnalyseSaisie);
  }




  valideNumeric(event :KeyboardEvent){
    let input =  this.dossierBloqueDto.resultatAnalyseSaisie;

    if(this.dossierBloqueDto.resultatAnalyseSaisie && this.dossierBloqueDto.resultatAnalyseSaisie.length >= this.MAX_CARACTERES)
      return false ;

    // si la valeur numerique commence  un -
    if(this.isEmpty(input) && "-" == event.key  ){
      return true;
    }

    //si la valeur numerique ne contient pas deux fois la virule
    if(event.key =='.' || event.key ==',' ){
      let virgule = event.key;
      return !input.includes('.');
    }

    return this.numericRegex.test(this.isEmpty(input) ? event.key : input+=event.key );
  }

  isSigne(value :string){
    return value == '-' || this.isEmpty(value);
  }

  handleNumericInputChange(){
    if (this.isNumeriqueInputResultat()) {
      if (this.dossierBloqueDto.resultatAnalyseSaisie.includes(',')) {
        this.dossierBloqueDto.resultatAnalyseSaisie = this.dossierBloqueDto.resultatAnalyseSaisie.replace(',', '.');
      }
      this.isValeurValide = this.isValeurNumeriqueValide();
      this.hasChampsValides.emit(this.isValeurValide);
    }
  }

  inputChange() {
    this.isMissedResultatAnlayseSaisie = false;
    if(this.isCodeInputResultat() && !this.isEmpty(this.dossierBloqueDto.resultatAnalyseSaisie)) {
      this.dossierBloqueDto.resultatAnalyseConfirm = true;
      this.hasChampsValides.emit(true);
    }
    this.handleNumericInputChange();
    this.setData.emit(this.dossierBloqueDto);
  }

  getInputColor(): string {
    if (this.isDonneeManquante()) {
      return "red";
    }
    return "gray"
  }

  isDonneeManquante() {
    if( this.dossierBloqueDto.resultatAnalyseSaisie == 'missed'){
      this.isMissedResultatAnlayseSaisie = true ;
      this.dossierBloqueDto.resultatAnalyseSaisie ='';
    }
    return this.isMissedResultatAnlayseSaisie;
  }


  getCorrespondantSaisie() {
    return this.dossierBloqueDto.codeCorrespondantSaisie;
  }

  hasValidationResult(){
    if(this.apiResult == null ||this.apiResult == undefined )
      return false ;
    if(this.apiResult.validationResults == null ||this.apiResult.validationResults == undefined )
      return false ;
    return true;
  }

  hasValidationResultOK(){
    return this.hasValidationResult() && this.apiResult.validationResults.filter(value => value.statusCode == 'OK' &&
      value.anomalyFix.cleLigneAnalyseResultat == this.dossierBloqueDto.cleLigneAnalyseResultat).length > 0 ;
  }

  hasValidationResultKO(){
    let results : ValidationResultsDto[];
    if( this.hasValidationResult())
    {
      results  = this.apiResult.validationResults.filter(value => value.statusCode == 'KO'
        && value.anomalyFix.cleLigneAnalyseResultat == this.dossierBloqueDto.cleLigneAnalyseResultat) ;

      if( results.length > 0)
      {
        this.returnMessage = results[0].returnMessage;
        return true;
      }
    }

    return false;
  }

  validerChamp(valeur: string, isConfirmer: boolean) {
    this.isDonneesDiscordantes = false;
    this.isBoutonValiderClique = true;
    if (this.valeurInitial !== '') {
      if (valeur === this.valeurInitial) {
        this.identicalInput = true;
        this.dossierBloqueDto.resultatAnalyseConfirm = true;
        this.hasVisaRequired.emit(true);
      } else {
        this.identicalInput = false;
        this.isDonneesDiscordantes = true;
        this.isBoutonValiderClique = false;
      }
    }
    this.valeurInitial = valeur;
    if (!isConfirmer || this.isDonneesDiscordantes === true) {
      this.dossierBloqueDto.resultatAnalyseSaisie = '';
    }
    if (this.isDonneesDiscordantes === true) {
      this.valeurInitial = '';
    }
    this.hasChampsValides.emit(this.isValeurValide);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/utils/dialog/dialog-donnees-manquantes/body-donnees-manquantes/body-donnees-manquantes.ts